import intl from "react-intl-universal";

import {AppState} from "@stores/AppState";
import {WorkspaceModelType} from "@stores/WorkspaceStore";
import {updateItemChildIdsAdd} from "./updateItem";
import {updateWorkspaceChildIdsRemove} from "../workspace/updateWorkspace";
import {showInWorkspace} from "../ui/showInWorkspace";
import {UndoableAction} from "../common/UndoableAction";
import {UndoableActionGroup} from "../common/UndoableActionGroup";
import {undoableFunctionCall} from "../common/undoableFunctionCall";
import {CrudServices} from "../../platform/services/types/ServiceDependencies";


export class UndoableAddToCluster implements UndoableAction {
    args: Parameters<typeof addToCluster>;
    undoableGroup: UndoableActionGroup;

    constructor(...args: Parameters<typeof addToCluster>) {
        this.undoableGroup = new UndoableActionGroup();
        this.args = args;
    }

    execute(): Promise<any> {
        /* @ts-ignore the last argument of moveItem is not used in initial constructor and exists only for this use-case */
        return addToCluster.apply(null, [...this.args, this.undoableGroup]);
    }

    undo(): Promise<any> {
        return this.undoableGroup.undo();
    }
}


export const undoableAddToCluster = (
    services: CrudServices,
    appState: AppState,
    itemId: string,
    targetClusterId: string,
    workspace: WorkspaceModelType
) => {
    const undoableAction = new UndoableAddToCluster(services, appState, itemId, targetClusterId, workspace);
    return undoableFunctionCall(undoableAction, intl.get('snackbar.add_to_cluster').d('Page added to cluster.'));
}

export const addToCluster = (
    services: CrudServices,
    appState: AppState,
    itemId: string,
    targetClusterId: string,
    workspace: WorkspaceModelType,
    undoableActionGroup?: UndoableActionGroup,
) => {
    const dsManager = appState.userState!.dsManager!;
    const clusterMST = workspace.items.get(targetClusterId)!;
    const itemMST = workspace.items.get(itemId)!;
    const wsUpdateServices = {...services, dsManager};
    let workspaceChangeWait = Promise.resolve();

    if (itemMST.parentIds.length === 0) {
        workspaceChangeWait = updateWorkspaceChildIdsRemove(wsUpdateServices, workspace, itemMST.id, undoableActionGroup);
    }

    const updateItemChildsWait = updateItemChildIdsAdd(services, dsManager, clusterMST, itemId, workspace, undefined, undoableActionGroup);
    showInWorkspace(appState.rootStore, itemId, workspace);

    return Promise.all([workspaceChangeWait, updateItemChildsWait]);
}
